import { Platform } from 'react-native';

import {
  Locale,
  MvEnv,
  Platform as MvPlatform,
} from '@mfe/shared/schema-types';
import { snakeCaseToCamelCase } from '@mfe/shared/utils';

import env from '../env/env';

export const rnPlatformToAuthPlatform = (
  rnPlatform: Platform['OS']
): MvPlatform | null => {
  switch (rnPlatform.toLocaleLowerCase()) {
    case 'web':
      return MvPlatform.Web;
    case 'ios':
      return MvPlatform.Ios;
    case 'android':
      return MvPlatform.Android;
  }

  return null;
};

export const getPlatform = (): MvPlatform | null => {
  if (Platform.OS !== 'web') return rnPlatformToAuthPlatform(Platform.OS);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const platform = window.NATIVE_APP_INFO?.platform ?? 'web';
  return rnPlatformToAuthPlatform(platform);
};

export const getEnv = (): MvEnv => {
  return snakeCaseToCamelCase(env.env) as MvEnv;
};

export const getAuthVars = () => {
  const platform = getPlatform() as MvPlatform;
  const env = getEnv();
  const mfeEnv = env;
  let locale: Locale = Locale.EnUs;

  if (
    Platform.OS === 'web' &&
    env === MvEnv.Prod &&
    window.location.hostname.includes('minha.viasat.com')
  ) {
    locale = Locale.PtBr;
  }

  if (Platform.OS === 'web' && window.location.href.includes('/it')) {
    locale = Locale.ItIt;
  }

  return { platform, env, mfeEnv, locale };
};
